export default __webpack_public_path__ + "static/media/arrow_7.97b33d99.svg";